import { useEffect, useRef } from "react"
import { refreshTokensIfNeeded } from "@/api/service"

export const useTokenRefresh = () => {
  const intervalRef = useRef<number | null>(null)

  useEffect(() => {
    const checkAndRefreshToken = async () => {
      await refreshTokensIfNeeded()
    }

    checkAndRefreshToken()

    intervalRef.current = window.setInterval(
      checkAndRefreshToken,
      5 * 60 * 1000
    )

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
    }
  }, [])
}
